import { TooltipPosition, TooltipProps } from './types';

import { css } from '@emotion/react';
import { Info } from 'lucide-react';
import UDTippy from 'ud-ui/components/tippy';
import React from 'react';
import { theme } from 'styles/theme/theme';

interface TooltipWrapperProps extends TooltipProps {
  position?: TooltipPosition;
  className?: string;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ tooltip, tooltipProps, position, className }) => {
  const tooltipPosition = position || tooltipProps?.position || 'right';
  const isInDevelopment = tooltipProps?.isInDevelopment;
  const maxWidth = tooltipProps?.maxWidth || '210px';

  const getTooltipIconClassName = () => {
    const positionClass = (() => {
      switch (tooltipPosition) {
        case 'left':
          return 'mr-1';
        case 'top-right':
          return 'ml-1 mb-1';
        case 'right':
          return 'ml-1';
        case 'input-left':
          return 'mr-2';
        case 'input-right':
          return 'ml-2';
        default:
          return '';
      }
    })();

    return `${positionClass} text-surfaceRaisinBlack50`;
  };

  if (!tooltip) return null;

  const tooltipContent = isInDevelopment ? (
    <div>
      <div style={{ color: theme.colors.CaseError }}>⚠️ Функционал в разработке!</div>
      <br />
      {tooltip}
    </div>
  ) : (
    tooltip
  );

  const developmentStyle = isInDevelopment
    ? css`
        .tippy-content {
          border: 2px solid ${theme.colors.CaseError};
          border-radius: 4px;
        }
      `
    : undefined;

  return (
    <UDTippy content={tooltipContent} maxWidth={maxWidth} {...tooltipProps} css={developmentStyle}>
      <Info
        size={16}
        className={`${getTooltipIconClassName()} ${className}`}
        style={{ cursor: 'help', minWidth: 16 }}
        color={tooltipProps?.color ?? (isInDevelopment ? theme.colors.CaseError : undefined)}
      />
    </UDTippy>
  );
};

export default TooltipWrapper;
